import ConfirmDialog from 'components/Dialog/ConfirmDialog'
import { useTranslation } from 'react-i18next'
import EachPhoneInfo from './EachPhoneInfo'
import { isEmpty } from 'lodash-es'
import { Box, Typography } from '@mui/material'
import { useCallerIdHubContext } from 'hooks/usePOSHubContext/usePOSHubContext'

interface MultipleActiveCallingDialogProps {
    open: boolean
    onClose: () => void
    onSelect: (phoneNumber: string) => void
}

function MultipleActiveCallingDialog(props: MultipleActiveCallingDialogProps) {
    const { t } = useTranslation()
    const { open, onClose, onSelect } = props
    const {
        removeCallerIdMessage,
        activePhoneCallerInfos,
    } = useCallerIdHubContext()

    return (
        <ConfirmDialog
            open={open}
            title={t('customers.title.active_calls')}
            onSave={() => {}}
            hideConfirmBtn
            onDiscard={onClose}
            fullWidth
            allowClose
        >
            {isEmpty(activePhoneCallerInfos) ? (
                <Box>
                    <Typography color="default.dark">
                        {t('customers.message.no_active_calls')}
                    </Typography>
                </Box>
            ) : (
                <>
                    <Typography variant="h6" fontWeight={'bold'}>
                        {t('customers.message.select_active_call')}
                    </Typography>
                    {activePhoneCallerInfos.map((info) => (
                        <EachPhoneInfo
                            key={info.phoneNumber}
                            phoneCallerInfo={info}
                            onClick={() => onSelect(info.phoneNumber)}
                            onRemove={() =>
                                removeCallerIdMessage(info.phoneNumber)
                            }
                        />
                    ))}
                </>
            )}
        </ConfirmDialog>
    )
}

export default MultipleActiveCallingDialog
